import { generateCallFlowUrl } from '../utils/url-builder.mjs';
import { fetchWithTimeout } from '../utils/fetch-with-timeout.mjs';
import { LIBRARY_VERSION } from '../utils/consts.mjs';

class CallFlowCDPClient {
    /**
     * A helper class which handles the functionality for sending CALLFLOW requests
     * @param personalizeData - The mandatory payload to be send to Sitecore CDP
     * @param settings - The global settings
     */
    constructor(settings) {
        this.settings = settings;
    }
    /**
     * A function that sends a CallFlow request to Sitecore CDP
     * @param personalizeData - Properties to be send to Sitecore CDP
     * @param timeout - Optional timeout in milliseconds to cancel the request
     * @returns - A promise that resolves with either the Sitecore CDP response object or unknown
     */
    async sendCallFlowsRequest(cdpCallFlowsBody, timeout) {
        const requestUrl = generateCallFlowUrl(this.settings.targetURL);
        const fetchOptions = {
            body: JSON.stringify(cdpCallFlowsBody),
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'Content-Type': 'application/json',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'X-Library-Version': LIBRARY_VERSION,
            },
            method: 'POST',
        };
        if (timeout === undefined)
            return fetch(requestUrl, fetchOptions)
                .then((response) => response.json())
                .then((data) => data)
                .catch(() => {
                return null;
            });
        return fetchWithTimeout(requestUrl, timeout, fetchOptions);
    }
}

export { CallFlowCDPClient };
